const routes = [
  {
    path: '/properties',
    name: 'Properties',
    component: () => import(
      /* webpackChunkName: "PropertiesModule" */
      '@/modules/Properties/PropertiesModule.vue'
    ),
    meta: {
      mainClasses: 'App-main__withall',
      hideAside: false,
      hideFooter: true,
      requiresAuth: true,
      requiresAccountSelected: true,
      requiresActiveProperties: true,
      accountSettingsPage: true,
    },
    children: [
      {
        path: '',
        name: 'properties',
        component: () => import(
          /* webpackChunkName: "PropertiesModule" */
          '@/modules/Properties/views/PropertyList.vue'
        ),
      },
      {
        path: ':id',
        name: 'property',
        component: () => import(
          /* webpackChunkName: "PropertiesModule" */
          '@/modules/Properties/views/PropertyDetails.vue'
        ),
      },
      {
        path: ':id/copy-preferences',
        name: 'property-copy-preferences',
        component: () => import(
          /* webpackChunkName: "PropertiesModule" */
          '@/modules/Properties/views/PropertyPreferencesCopy.vue'
        ),
      },
    ],
  },
];

export default routes;
